const sessionStorageKey = 'brain-player-live-session-v1';

export function getClientSessionId(): string {
  try {
    const existing = sessionStorage.getItem(sessionStorageKey);
    if (existing) return existing;
    const generated = typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(sessionStorageKey, generated);
    return generated;
  } catch {
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  }
}
